// // Use $ instead of jQuery without replacing global $
(function ($) {

    $(document).ready(function () {
        var ctr = 0;
        $('.column-grid.partners .grid-outer .card .inner-wrap').on('click', function (e) {
            var $this = $(this);

            if (ctr > 0) {
                $('.content-overlay .slider-outer .slider .inner-item.slick-initialized').slick('unslick');
            }
            setTimeout(function () {
                $this.parent().find('.content-overlay .slider-outer .slider .inner-item').slick({
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    draggable: false,
                    speed: 800,
                    prevArrow: $('.column-grid.partners .grid-outer .card .content-overlay .slider-outer .slide-nav .slide-prev'),
                    nextArrow: $('.column-grid.partners .grid-outer .card .content-overlay .slider-outer .slide-nav .slide-next'),
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                draggable: true
                            }
                        }
                    ]
                });
            }, 100);

            ctr++;

        });
    });
})(jQuery);